import { Mail, Megaphone, MessageCircle } from "lucide-react";
import { LINKS } from "@/lib/site";
import { Reveal, SectionLabel } from "@/components/Reveal";

const Advertise = () => (
  <section
    id="advertise"
    data-testid="advertise-section"
    className="relative overflow-hidden border-t border-white/5 bg-charcoal py-14 lg:py-20"
  >
    <div
      aria-hidden
      className="absolute inset-0"
      style={{
        background:
          "radial-gradient(50% 60% at 90% 0%, rgba(255,255,255,0.06), transparent 70%), radial-gradient(35% 45% at 0% 100%, rgba(37,211,102,0.06), transparent 70%)",
      }}
    />
    <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 lg:grid-cols-[1.25fr_1fr] lg:px-10">
      <Reveal>
        <SectionLabel>Advertise</SectionLabel>
        <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white md:text-4xl lg:text-[2.75rem] lg:leading-[1.12]">
          Reach the JGW Audience
        </h2>
        <div className="mt-5 h-px w-16 bg-gradient-to-r from-silver/60 to-transparent" />
        <p className="mt-5 max-w-lg text-base leading-relaxed text-silver md:text-lg">
          Promote your business through Jewish Global Wire and reach an engaged
          audience directly through WhatsApp.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:gap-4">
          <a
            href={LINKS.advertise}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="advertise-whatsapp-button"
            className="inline-flex items-center justify-center gap-2.5 rounded-xl bg-whatsapp px-7 py-4 text-sm font-bold text-white shadow-[0_12px_32px_-8px_rgba(37,211,102,0.45)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-whatsapp-dark"
          >
            <MessageCircle size={18} strokeWidth={2.2} />
            Advertise With JGW
          </a>
          <a
            href={LINKS.email}
            data-testid="advertise-email-button"
            className="inline-flex items-center justify-center gap-2.5 rounded-xl border border-white/30 bg-white/5 px-7 py-4 text-sm font-bold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:text-black"
          >
            <Mail size={18} strokeWidth={2.2} />
            Email Our Team
          </a>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="rounded-2xl border border-white/10 bg-black/40 p-6 backdrop-blur-sm sm:p-7">
          <p className="flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.22em] text-silver">
            <Megaphone size={15} className="text-whatsapp" />
            Advertising Team
          </p>
          <div className="mt-5 space-y-4">
            <a
              href={LINKS.phoneHref}
              data-testid="advertise-phone-link"
              className="group flex items-center gap-4"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-whatsapp transition-colors duration-200 group-hover:bg-whatsapp group-hover:text-white">
                <MessageCircle size={18} strokeWidth={2} />
              </span>
              <span>
                <span className="block text-[11px] font-semibold uppercase tracking-[0.15em] text-silver-dark">
                  WhatsApp
                </span>
                <span className="block text-[15px] font-bold text-white transition-colors duration-200 group-hover:text-whatsapp">
                  {LINKS.phoneDisplay}
                </span>
              </span>
            </a>
            <div className="hairline" />
            <a
              href={LINKS.email}
              data-testid="advertise-email-link"
              className="group flex items-center gap-4"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-silver-light transition-colors duration-200 group-hover:bg-white group-hover:text-black">
                <Mail size={18} strokeWidth={2} />
              </span>
              <span>
                <span className="block text-[11px] font-semibold uppercase tracking-[0.15em] text-silver-dark">
                  Email
                </span>
                <span className="block break-all text-[15px] font-bold text-white transition-colors duration-200 group-hover:text-silver-light">
                  {LINKS.emailAddress}
                </span>
              </span>
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Advertise;
